/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const OrderRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        height={80}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: SkeletonSettings.BORDER}}
        {...props}>

        {/* Order number and label */}
        <rect x="0" y={`calc(50% - 5px)`} rx="3" ry="3" width="5%" height="10"/>
        <rect x={`calc(5% + 10px)`} y={`calc(50% - 10px)`} rx="3" ry="3" width="8%" height="20"/>

        {/* Order reference */}
        <rect x="20%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Creation date */}
        <rect x="36%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Ship-to number */}
        <rect x="52%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* City */}
        <rect x="68%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* View more button */}
        <rect x={"85%"} y={`calc(50% - 20px)`} rx="3" ry="3" width="15%" height="40"/>

    </ContentLoader>
)
